import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id DAA3B240-E394-46A8-83FE-6EE6712BF806
 * name shuffle-disabled
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shuffle-disabled.svg
 * tags
 * - Arrow 
 */
export const ShuffleDisabledIcon = createSvgIcon(<><path d="M16,4.5V7H5V9H16V11.5L19.5,8M16,12.5V15H5V17H16V19.5L19.5,16" /></>, 'ShuffleDisabledIcon');
export default ShuffleDisabledIcon